import { useContext } from 'react';
import { SetupFlowContext } from 'accounts/contexts/setup-flow';

export function useSetupFlow() {
  const flowStep = useContext(SetupFlowContext);

  // Same as `useSetupFlowStep`: consumers all render underneath
  // `SetupFlowProvider` and destructure this immediately, so the `undefined`
  // that `createContext` demands as a default is never observed.
  return flowStep!;
}
